export function logEvt(eventName: string, detail?: unknown): void {
  try {
    if ((import.meta as any).env?.VITE_NAV_DEBUG) {
      if (typeof detail !== 'undefined') {
        console.log(`[evt:${eventName}]`, detail);
      } else {
        console.log(`[evt:${eventName}]`);
      }
    }
  } catch {
    // no-op in non-browser / unexpected environments
  }
}
